import React, { Fragment } from "react";
import spinner from "../../images/spinner.gif";

const Spinner = () => (
  <Fragment>
    <img
      src={spinner}
      alt="Loading..."
      style={{ width: "200px", margin: "auto", display: "block" }}
    />
  </Fragment>
);

const SmallSpinner = () => (
  <Fragment>
    <img
      src={spinner}
      alt="processing ... "
      style={{ width: "50px", margin: "auto", display: "block" }}
    />
  </Fragment>
);

export { Spinner, SmallSpinner };
